export * from './banner.component'
